export default __webpack_public_path__ + "img/editor_user.d23b55d3.svg";